"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withCreateVote = void 0;
const web3_js_1 = require("@solana/web3.js");
const sdk_1 = require("./sdk");
const accounts_1 = require("./accounts");
/**
 * Generating an instruction to create a new directed stake vote record account
 * which is a PDA address of root and owner.
 *
 * Instruction requires signature of owner and rentPayer.
 *
 * @type {Object} args - Arguments on instruction creation
 * @param {DirectedStakeSdk} args.sdk - Directed stake SDK instance
 * @param {PublicKey} args.root - Address of the directed stake root account that the vote record will be created under
 * @param {PublicKey} args.target - Target which the vote record will be created for
 * @param {PublicKey} args.rentPayer - Payer of the rent excempt price the vote record is created with
 *                                    (when not passed as the argument the sdk wallet will be taken as the payer)
 * @type {Object} return - Return data of generated instruction
 * @return {TransactionInstruction} return.instruction - Instruction to create a new vote record
 * @return {PublicKey} return.address - Address of the new vote record to be created when the instruction is executed
 */
async function withCreateVote({ sdk, root = new web3_js_1.PublicKey(sdk_1.DEFAULT_DIRECTED_STAKE_ROOT), target, rentPayer, }) {
    const owner = sdk.program.provider.publicKey;
    rentPayer = (rentPayer || sdk.program.provider.publicKey);
    const voteRecord = (0, accounts_1.voteRecordAddress)({
        directedStakeProgramId: sdk.program.programId,
        root,
        owner,
    }).address;
    const instruction = await sdk.program.methods
        .createVote(target)
        .accountsStrict({
        voteRecord,
        root,
        owner,
        rentPayer,
        systemProgram: web3_js_1.SystemProgram.programId,
    })
        .instruction();
    return { address: voteRecord, instruction };
}
exports.withCreateVote = withCreateVote;
//# sourceMappingURL=withCreateVote.js.map